module.exports = __webpack_public_path__ + "static/media/with_astrnt.3e145117.png";